// Stage 97: WARP — host-snapshot → widget-shape adapter.
//
// The host's useGadflyTurn publishes a GadflyTurnState with
// swatEntries[] (array) and stripeRatioApplied. The widget tree
// consumes a WarpTurnState with swats{biteIndex: SwatEntry} and
// stripeRatio. This hook bridges the two — memoized over the host
// snapshot reference so identity is stable across re-renders.
//
// This is the ONLY direction in which Warp/ may read from
// hooks/useGadflyTurn. Do not add additional cross-imports.

import { useMemo } from 'react';
import type { GadflyTurnState } from '../../hooks/useGadflyTurn';
import type { SwatEntry } from '../../api/gadfly';
import type { WarpTurnState } from './types';

export function useGadflyTurnAdapter(host: GadflyTurnState): WarpTurnState {
  return useMemo(() => {
    const swats: Record<number, SwatEntry> = {};
    for (const e of host.swatEntries ?? []) {
      swats[e.biteIndex] = e;
    }
    return {
      turnId: host.turnId,
      bites: host.bites,
      swats,
      failed: host.failed,
      failureReason: host.failureReason,
      durationMs: host.durationMs,
      modelUsed: host.modelUsed,
      stripeRatio: host.stripeRatioApplied,
      generatedAt: host.generatedAt,
      turnEnded: host.turnEnded,
    };
  }, [host]);
}
